/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Form for attaching an organization JSON Web Key Set to a remote_session_client.
 */
export type AttachKeySetForm = {
  /**
   * The remote_session_client id.
   */
  id: string;
  /**
   * The organization JSON Web Key Set to sign this client's private_key_jwt assertions with. Must belong to the client's organization.
   */
  jsonWebKeySetId: string;
};

/** @internal */
export type AttachKeySetForm$Outbound = {
  id: string;
  json_web_key_set_id: string;
};

/** @internal */
export const AttachKeySetForm$outboundSchema: z.ZodMiniType<
  AttachKeySetForm$Outbound,
  AttachKeySetForm
> = z.pipe(
  z.object({
    id: z.string(),
    jsonWebKeySetId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      jsonWebKeySetId: "json_web_key_set_id",
    });
  }),
);

export function attachKeySetFormToJSON(
  attachKeySetForm: AttachKeySetForm,
): string {
  return JSON.stringify(
    AttachKeySetForm$outboundSchema.parse(attachKeySetForm),
  );
}
